export const VERIFICATION_ORGANIZATION_ID = '90a06027-714c-4242-b221-abcf015d975c';
